import { m } from '@hub/messages';
import { definePageRoute } from '@hub/router/definePageRoute';
import { type DomainParents, defineDomainRoutes } from '@hub/router/domain-routes';
import { getParentalControlsVerificationOptions } from '@platform/api';
import { ParentalControlsPaths } from './route.paths';

export default function createParentalControlsRoutes(parents: DomainParents) {
  const overviewRoute = definePageRoute(parents, {
    path: ParentalControlsPaths.overview,
    title: m.parental_controls_page_title,
    description: m.parental_controls_page_description,
    page: () => import('./ParentalControls.page'),
    flag: 'page-parental-controls',
    pendingComponent: () => import('./components/ParentalControlsSkeleton'),
    query: getParentalControlsVerificationOptions,
    quickAction: {
      to: ParentalControlsPaths.overview.path,
      icon: 'parental-control',
      title: m.parental_controls_quick_action_title,
      subline: m.parental_controls_quick_action_subline,
      surfaces: ['home-account', 'personal-data', 'invoices-actions', 'payment-change-actions'],
      order: 40,
    },
  });

  return defineDomainRoutes({
    authenticated: [overviewRoute] as const,
    public: [] as const,
  });
}
